import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '~/core/services/auth.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
    public email: string = '';
    public password: string = '';
    public showPassword: boolean = false;
    public isLoading: boolean = false;
    public errorMessage: string = '';
    public successMessage: string = '';

    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    ngOnInit(): void {
        // If already logged in, redirect to bu-selection
        if (this.authService.isAuthenticated) {
            this.router.navigate(['/']);
        }
    }

    togglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    onSignIn(): void {
        // Validate inputs
        if (!this.email.trim()) {
            this.errorMessage = 'Please enter your email';
            return;
        }

        if (!this.password) {
            this.errorMessage = 'Please enter your password';
            return;
        }

        this.isLoading = true;
        this.errorMessage = '';
        this.successMessage = '';

        this.authService.login(this.email, this.password).subscribe(
            (response) => {
                this.isLoading = false;

                if (response.success) {
                    this.successMessage = 'Login successful! Redirecting...';
                    setTimeout(() => {
                        this.router.navigate(['/']);
                    }, 500);
                } else {
                    this.errorMessage = response.message || 'Login failed. Please try again.';
                }
            },
            (error) => {
                this.isLoading = false;
                this.errorMessage = 'An error occurred. Please try again.';
                console.error('Login error:', error);
            }
        );
    }

    onKeyPress(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.onSignIn();
        }
    }
}
